import { useEffect } from 'react'

import { useSession } from 'next-auth/react'
import { useRouter } from 'next/router'

import Auth from '@components/profile/Auth'

export default function Register() {
	const { data: session, status } = useSession()
	const router = useRouter()

	useEffect(() => {
		if (!session) return

		// TODO: handle redirect dynamically
		router.push('/profile/subscriptions')
	}, [session, router])

	if (status === 'unauthenticated')
		return (
			<section className="section">
				<div className="container flex flex-col items-center justify-center">
					<Auth step="sign-up" />
				</div>
			</section>
		)

	return null
}
